import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import styled from 'styled-components'
import { apiUrl } from '../../globals'
import moment from 'moment'

import { CertificateState, VerifyExamResponse } from "./types"
import { FlexRow } from "../FlexboxReusables/FlexItems"
import { Logo } from "../../assets/Logo"
import Background from "../../assets/Background"
import LoadingSpinner from "../LoadingSpinner"
import { renderValidCertificate } from "./renderValidCertificate"
import { renderInvalidCertificate } from "./renderInvalidCertificate"
import { renderExpiredCertificate } from "./renderExpiredCertificate"
import NotFound from "../../Routes/PageNotFound"

const VerifyCertificate = () => {
  const examId = useParams().examId
  const [ data, setData ] = useState<VerifyExamResponse | null>(null)
  const [ state, setState ] = useState({ isValid: false, isExpired: false, isLoading: true })

  useEffect(() => {
    const getVerificationData = async () => {
      try {
        const res = await axios.get(`${apiUrl}/verify-certificate/${examId}`)
        if (res.status === 200) {
          setData(res.data)
          const validityEndDate = moment(res.data.examFinishedAt).add(res.data.examValidityMonths, 'months')
          const isCertificateValid = res.data.hasPassed && moment().isBefore(validityEndDate)
          setState({
            isValid: isCertificateValid,
            isExpired: !isCertificateValid && !moment().isBefore(validityEndDate),
            isLoading: false
          })
        }
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          setState({ isValid: false, isExpired: false, isLoading: false })
        } else {
          setState({ isValid: false, isExpired: false, isLoading: false })
        }
      }
    }
    getVerificationData()
  }, [ examId ])

  const conditionallyRenderCertificate = (data: VerifyExamResponse) => {
    let certificateState
  
    if (state.isValid) {
      certificateState = CertificateState.VALID
    } else if (state.isExpired) {
      certificateState = CertificateState.EXPIRED
    } else {
      certificateState = CertificateState.INVALID
    }
  
    switch (certificateState) {
      case CertificateState.VALID:
        return renderValidCertificate(data)
      case CertificateState.EXPIRED:
        return renderExpiredCertificate(data)
      case CertificateState.INVALID:
        return renderInvalidCertificate()
      default:
        return <NotFound />
    }
  }

  if (state.isLoading) {
    return <LoadingSpinner />
  }

  return data && (
    <>
      <Background />
      <Container>
        <FlexRow>
          <Logo />
          <CourseWareText>CourseWare</CourseWareText>
        </FlexRow>
        {conditionallyRenderCertificate(data)}
      </Container>
    </>
  )
}

export default VerifyCertificate

const Container = styled.div`
  position: absolute;
  top: 30%;
  left: 15%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const CourseWareText = styled.h1`
  font-size: 1.5em;
  font-weight: bold;
  margin-top: 0.6em;
  color: #14CCAA;
`